import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Seo from "../components/Seo";
import { api, formatApiError } from "../lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export function NewsletterConfirm() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading", message: "" });
  useEffect(() => {
    const token = params.get("token") || "";
    api.get(`/newsletter/confirm?token=${encodeURIComponent(token)}`)
      .then(() => setState({ status: "success", message: "Your subscription is confirmed. Thank you for staying connected with Mount Moriah Relief." }))
      .catch((err) => setState({ status: "error", message: formatApiError(err) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ResultPage state={state} okTitle="Subscription confirmed" seoPath="/newsletter/confirm" seoTitle="Confirm subscription" />
  );
}

export function NewsletterUnsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading", message: "" });
  useEffect(() => {
    const token = params.get("token") || "";
    api.get(`/newsletter/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(() => setState({ status: "success", message: "You have been unsubscribed. You will no longer receive our email updates." }))
      .catch((err) => setState({ status: "error", message: formatApiError(err) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ResultPage state={state} okTitle="You are unsubscribed" seoPath="/newsletter/unsubscribe" seoTitle="Unsubscribe" />
  );
}

function ResultPage({ state, okTitle, seoPath, seoTitle }) {
  return (
    <div className="py-32">
      <Seo title={seoTitle} path={seoPath} />
      <div className="max-w-md mx-auto px-6 text-center bg-white border border-sandstone p-10">
        {state.status === "loading" && <p className="text-charcoal/60">Please wait…</p>}
        {state.status === "success" && (
          <>
            <CheckCircle2 size={36} strokeWidth={1.5} className="text-forest mx-auto" aria-hidden="true" />
            <h1 className="mt-5 font-serif text-3xl font-semibold text-forest">{okTitle}</h1>
            <p className="mt-3 text-sm text-charcoal/75 leading-relaxed" data-testid="newsletter-result-message">{state.message}</p>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle size={36} strokeWidth={1.5} className="text-red-700 mx-auto" aria-hidden="true" />
            <h1 className="mt-5 font-serif text-3xl font-semibold text-charcoal">Something went wrong</h1>
            <p className="mt-3 text-sm text-charcoal/75 leading-relaxed" data-testid="newsletter-result-error">{state.message}</p>
          </>
        )}
        <Link to="/" className="mt-6 inline-block text-sm text-forest underline" data-testid="newsletter-result-home-link">
          Return to the homepage
        </Link>
      </div>
    </div>
  );
}
